import React from "react";
import CustomTextbox from "../../components/Forms/CustomInputs/CustomTextbox";
import CustomMobileWithCountryCode from "../../components/Forms/CustomInputs/CustomMobileWithCountryCode";
import { useSelector } from "react-redux";
import CustomDropdown from "../../components/Forms/CustomInputs/CustomDropdown";
import CustomTextarea from "../../components/Forms/CustomInputs/CustomTextarea";
import CustomImageUpload from "../../components/Forms/CustomInputs/CustomImageUpload";
import { date } from "yup";

const AddUpdateUI = ({
  formik,
  selectedRelationData,
  setSelectedRelationData,
  isLeadArtist,
  showrole,
}) => {
  const { values, errors, handleChange, handleBlur, setFieldValue, touched, setFieldTouched } =
    formik;
  const { data: cities } = useSelector((state) => state.city);
  const { data: states } = useSelector((state) => state.state);
  const genderOptions = [
    { name: "Select gender", value: "" },
    { name: "Male", value: "Male" },
    { name: "Female", value: "Female" },
    { name: "Prefer Not to Share", value: "Prefer Not to Share" },
  ];
  // helper to format DOB for <input type="date">
  const formatDobForInput = (dob) => {
    if (!dob) return "";
    const d = new Date(dob);
    if (isNaN(d)) return "";
    return d.toISOString().slice(0, 10); // YYYY-MM-DD
  };
  // selected gender object (CustomDropdown expects {label, value} like other dropdowns)
  // const selectedGenderObj = genderOptions.find(
  //   (g) => g.value === values.gender
  // ) || { name: "Select gender", value: "" };

  const selectedGenderObj = genderOptions.find(
    (g) =>
      g.value.toLowerCase() ===
      String(values.gender || "")
        .toLowerCase()
        .trim()
  ) || { name: "Select gender", value: "" };

  return (
    <>
      <div className="row">
        <CustomImageUpload
          fieldName="profile_image"
          value={values.profile_image}
          error={errors.profile_image}
          label={"Upload Artist’s Profile Pictuer (1:1)"}
          classes={"col-md-12"}
          handleBlur={handleBlur}
          inputType={"text"}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          imageRatio="1_1"
        />
        <CustomTextbox
          fieldName="firstName"
          value={values.firstName}
          error={touched.firstName ? errors.firstName : null}
          label={"First Name of the Artist"}
          classes={"col-md-6"}
          handleBlur={handleBlur}
          inputType={"text"}
          handleChange={handleChange}
        />
        <CustomTextbox
          fieldName="lastName"
          value={values.lastName}
          error={touched.lastName ? errors.lastName : null}
          label={"Last Name of the Artist"}
          classes={"col-md-6"}
          handleBlur={handleBlur}
          inputType={"text"}
          handleChange={handleChange}
        />
        {showrole ? (
          <>
            <CustomTextbox
              fieldName="role"
              value={values.role}
              error={touched.role ? errors.role : null}
              label={"Role of the Artist in project"}
              classes={"col-md-6"}
              handleBlur={handleBlur}
              inputType={"text"}
              handleChange={handleChange}
            />
            <div className="col-md-6"></div>
          </>
        ) : null}
        <CustomTextbox
          fieldName="email"
          value={values.email}
          error={touched.email ? errors.email : null}
          label={"Email"}
          classes={"col-md-6"}
          handleBlur={handleBlur}
          inputType={"text"}
          handleChange={handleChange}
        />

        <CustomMobileWithCountryCode
          fieldName="mobileNumber"
          // disabled={true}
          disabled={isLeadArtist}
          countryCodeField="countryCode"
          value={values.mobileNumber}
          error={touched.mobileNumber ? errors.mobileNumber : null}
          label={"Mobile"}
          classes={"col-md-6"}
          // handleBlur={handleBlur}
          handleBlur={() => {
            setFieldTouched("mobile", true, true);
          }}
          inputType={"text"}
          setFieldValue={setFieldValue}
          country_code={values?.countryCode}
          handleChange={(e) => {
            if (e.target.value == "") {
              setFieldValue("mobileNumber", "");
            } else {
              if (/[0-9]/.test(e.target.value))
                setFieldValue("mobileNumber", e.target.value);
            }
          }}
        // maxLength={15}
        // minLength={10}
        />

        <CustomDropdown
          fieldName="state"
          values={selectedRelationData?.state}
          error={touched.state ? errors.state : null}
          label={"State"}
          classes={"col-md-6"}
          setFieldValue={setFieldValue}
          handleChange={(value) => {
            setSelectedRelationData({
              ...selectedRelationData,
              state: value,
              city: {},
            });
            setFieldValue("city", "");
          }}
          options={
            states
              ? states?.map((data) => {
                return { label: data.name, value: data._id };
              })
              : []
          }
        />

        <CustomDropdown
          fieldName="city"
          values={selectedRelationData?.city} // <-- here
          error={touched.city ? errors.city : null}
          label={"City"}
          classes={"col-md-6"}
          setFieldValue={setFieldValue}
          handleChange={(city) => {
            setFieldValue("city", city?.value || ""); // store only the _id in Formik
            setSelectedRelationData({
              ...selectedRelationData,
              city: { label: city.label, value: city.value }, // keep same structure as options
            });
          }}
          options={
            cities
              ? cities?.map((data) => {
                return { label: data.name, value: data._id };
              })
              : []
          }
        />
        <div className="col-6">
          <label className="text-label">Date of Birth *</label>
          <input
            name="dob"
            type="date"
            max={new Date().toISOString().split("T")[0]}
            value={formatDobForInput(values.dob)}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={(e) => {
              if (!e.target.value) {
                // open calendar at 2000-01-01 but don't fill input
                e.target.value = "2000-01-01";
                e.target.showPicker && e.target.showPicker(); // Chrome-specific
                e.target.value = ""; // reset so input looks empty
              }
            }}
            className={`form-control input col-6`}
          />
          {/* {errors.dob && touched.dob && (
            <div className="invalid-feedback d-block">{errors.dob}</div>
          )} */}
          {errors.dob && touched.dob ? (
            <div
              id={`val-dob-error`}
              class="invalid-feedback animated fadeInUp"
              style={{ display: "block" }}
            >
              {errors.dob}
            </div>
          ) : null}
        </div>
        <CustomDropdown
          fieldName="gender"
          values={{
            label:
              selectedGenderObj.name ||
              selectedGenderObj.label ||
              "Select gender",
            value: selectedGenderObj.value,
          }}
          error={touched.gender ? errors.gender : null}
          label={"Gender"}
          classes={"col-md-6"}
          setFieldValue={(field, val) => setFieldValue(field, val)}
          handleChange={(value) => {
            // value is expected as {label, value}
            setFieldValue("gender", value?.value || "");
          }}
          options={genderOptions.map((data) => {
            return { label: data.name, value: data.value };
          })}
        />
        <CustomTextbox
          fieldName="instagramProfile"
          value={values.instagramProfile}
          error={touched.instagramProfile ? errors.instagramProfile : null}
          label={"Instagram Profile"}
          classes={"col-md-12"}
          handleBlur={handleBlur}
          inputType={"text"}
          handleChange={handleChange}
        />

        <CustomTextarea
          errors={touched.description ? errors : { description: false }}
          setFieldValue={setFieldValue}
          handleBlur={handleBlur}
          values={values}
          fieldName={"description"}
          title={"Short Bio"}
        />

        <CustomImageUpload
          fieldName="portfolioPdf"
          value={values.portfolioPdf}
          error={errors.portfolioPdf}
          label={"Your Profile/Portfolio (PDF Only)"}
          classes={"col-md-12"}
          handleBlur={handleBlur}
          inputType={"text"}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          mediaType="pdf"
        />

        <div
          className={`form-group col-md-12 mb-3 ${errors?.referenceLinks?.[0] ? "is-invalid" : "is-valid"
            }`}
        >
          <label className="text-label">Links to Reference Work - 1</label>
          <input
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.referenceLinks[0] ?? ""}
            className="input form-control"
            name="referenceLinks[0]"
          />
          {errors?.referenceLinks?.[0] && (
            <div
              id="val-referenceLinks[0]-error"
              class="invalid-feedback animated fadeInUp"
              style={{ display: "block" }}
            >
              {errors?.referenceLinks?.[0]}
            </div>
          )}
        </div>

        <div
          className={`form-group col-md-12 mb-3 ${errors?.referenceLinks?.[1] ? "is-invalid" : "is-valid"
            }`}
        >
          <label className="text-label">Links to Reference Work - 2</label>
          <input
            onChange={handleChange}
            onBlur={handleBlur}
            value={values?.referenceLinks?.[1] ?? ""}
            className="input form-control"
            name="referenceLinks[1]"
          />
          {errors?.referenceLinks?.[1] && (
            <div
              id="val-referenceLinks[1]-error"
              class="invalid-feedback animated fadeInUp"
              style={{ display: "block" }}
            >
              {errors?.referenceLinks?.[1]}
            </div>
          )}
        </div>

        <div
          className={`form-group col-md-12 mb-3 ${errors?.referenceLinks?.[2] ? "is-invalid" : "is-valid"
            }`}
        >
          <label className="text-label">Links to Reference Work - 3</label>
          <input
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.referenceLinks[2] ?? ""}
            className="input form-control"
            name="referenceLinks[2]"
          />
          {errors?.referenceLinks?.[2] && (
            <div
              id="val-referenceLinks[2]-error"
              class="invalid-feedback animated fadeInUp"
              style={{ display: "block" }}
            >
              {errors?.referenceLinks?.[2]}
            </div>
          )}
        </div>

        {/* Hidden field for hearAbout */}
        <input
          type="hidden"
          name="hearAbout"
          value={values.hearAbout || "admin"}
          onChange={handleChange}
        />
      </div>
    </>
  );
};

export default AddUpdateUI;
